import * as yup from 'yup';
import { maxLength } from '../../../constants';

export const reportValidation = yup.object().shape({
  reportTitle: yup.string().max(75, `${maxLength} 75`),
});
